export const FEATURE_NEWS_KICKERS = [
  "New Feature",
  "Release Note",
  "Product Update",
  "Just shipped",
];

export const FEATURE_NEWS_DESIGNS = [
  {
    id: "aurora",
    name: "Aurora",
    kicker: "New Feature",
    description: "Soft peach header",
  },
  {
    id: "editorial",
    name: "Editorial",
    kicker: "Release Note",
    description: "Cream header, left accent",
  },
  {
    id: "midnight",
    name: "Sky",
    kicker: "Product Update",
    description: "Light blue header",
  },
  {
    id: "pulse",
    name: "Pulse",
    kicker: "Just shipped",
    description: "Mint header, outlined badge",
  },
];

export const DEFAULT_FEATURE_NEWS_DESIGN = "aurora";

export const getFeatureNewsDesign = (designId) =>
  FEATURE_NEWS_DESIGNS.find((design) => design.id === designId) ||
  FEATURE_NEWS_DESIGNS[0];

export const getFeatureNewsKicker = (item) => {
  const kicker = String(item?.kicker || "").trim();
  if (kicker) {
    return kicker;
  }
  return getFeatureNewsDesign(item?.designId).kicker;
};
